import { createFileRoute } from '@tanstack/react-router';
import { useCallback } from 'react';

import { SeoPage, type SeoTab } from '@/features/seo/SeoPage';

export interface SeoSearch {
  /** Открытая вкладка; без параметра — редиректы. */
  tab?: SeoTab;
}

export const Route = createFileRoute('/_app/seo')({
  validateSearch: (search: Record<string, unknown>): SeoSearch => ({
    tab: search.tab === 'robots' ? search.tab : undefined,
  }),
  component: SeoRoute,
});

function SeoRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  const onTabChange = useCallback(
    (tab: SeoTab) => {
      void navigate({ search: { tab: tab === 'redirects' ? undefined : tab } });
    },
    [navigate],
  );

  return <SeoPage tab={search.tab ?? 'redirects'} onTabChange={onTabChange} />;
}
